// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qI3FD","importantInfo":"styles_importantInfo__1_hY3"};